<template>
  <div v-if="this.$route.query.t == 'candidate'">
    <div class="wrapper">
      <div id="formContent">
        <!-- Tabs Titles -->

        <!-- Icon -->
        <div>
          <font-awesome-icon :icon="['fas', 'user']" size="5x" class="m-auto text-primary pt-3" />
          <h3 class="text-capitalize">{{ this.$route.query.t }} Registration</h3>
        </div>

        <div>
          <b-alert variant="danger" dismissable :show="errors.length > 0">
            <span v-for="(e, i) in errors" :key="i">
                {{e}}
            </span>
          </b-alert>
        </div>

        <!-- Login Form -->
        <form @submit.prevent="register">
          <input
            type="text"
            id="email"
            name="email"
            placeholder="Email"
            class="form-control"
            v-model="email"
          />
          <input
            :type="view ? 'text' : 'password'"
            id="password"
            name="password"
            class="form-control ml-4"
            placeholder="Password"
            v-model="password"
            required
            @change="confirmPasswordsMatch"
          />
          <font-awesome-icon
            id="regPassword"
            fas
            :icon="view ? 'eye-slash' : 'eye'"
            size="2x"
            @click="toggleView"
          />
          <input
            :type="viewConfirm ? 'text' : 'password'"
            id="confirmPassword"
            name="confirmPassword"
            class="form-control ml-4"
            placeholder="Confirm Password"
            v-model="confirmPassword"
            @change="confirmPasswordsMatch"
            required
          />
          <font-awesome-icon
            id="regConfirmPassword"
            fas
            :icon="viewConfirm ? 'eye-slash' : 'eye'"
            size="2x"
            @click="toggleConfirmView"
          />
          <b-form-checkbox id="checkbox-1" v-model="agreed">
            I agree to the
            <b-link href="https://www.careerpilot.co/termsofservice" target="_BLANK">Terms of Service</b-link>&nbsp;and
                <b-link href="https://www.careerpilot.co/privacy" target="_BLANK">Privacy Policy</b-link>
          </b-form-checkbox>
          <input
            type="submit"
            value="Register"
            :disabled="!isValid || !agreed || errors.length > 0"
            class="btn btn-lg btn-primary my-3 py-2 px-5"
          />
        </form>

        <!-- Remind Passowrd -->
        <div id="formFooter">
          <b-link class="underlineHover" to="/login">Already have an account? Login!</b-link>
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <div class="wrapper">
      <div id="formContent">
        <!-- Icon -->
        <div>
          <font-awesome-icon :icon="['fas', 'user']" size="5x" class="m-auto text-primary pt-3" />
          <h3 class="text-capitalize">{{ this.$route.query.t }} Registration</h3>
        </div>

        <b-alert variant="danger" dismissable :show="errors.length > 0">
          <span v-for="(e, i) in errors" :key="i">
              {{e}}
          </span>
        </b-alert>

        <!-- Login Form -->
        <form @submit.prevent="registerCompany">
          <b-form-row>
            <b-col sm="12">
              <b-form-group id="companyNameLabel">
                <b-form-input
                  type="text"
                  id="companyName"
                  v-model="company.name"
                  placeholder="Company Name"
                  required
                  trim
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="12">
              <b-form-group id="emailLabel">
                <b-form-input
                  type="text"
                  id="email"
                  placeholder="Email"
                  class="form-control"
                  v-model="email"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="12">
              <b-form-group id="passwordLabel">
                <b-form-input
                  :type="view ? 'text' : 'password'"
                  id="password"
                  class="form-control ml-4"
                  placeholder="Password"
                  v-model="password"
                  @change="confirmPasswordsMatch"
                  required
                />
                <font-awesome-icon
                  id="regPassword"
                  fas
                  :icon="view ? 'eye-slash' : 'eye'"
                  size="2x"
                  @click="toggleView"
                />
                <input
                  :type="viewConfirm ? 'text' : 'password'"
                  id="confirmPassword"
                  name="confirmPassword"
                  class="form-control ml-4"
                  placeholder="Confirm Password"
                  v-model="confirmPassword"
                  @change="confirmPasswordsMatch"
                  required
                />
                <font-awesome-icon
                  id="regConfirmPassword"
                  fas
                  :icon="viewConfirm ? 'eye-slash' : 'eye'"
                  size="2x"
                  @click="toggleConfirmView"
                />
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12">
              <b-form-checkbox v-model="compAgreed" class="mb-3">
                I agree to the
                <b-link href="https://www.careerpilot.co/termsofservice" target="_BLANK">Terms of Service</b-link>&nbsp;and
                <b-link href="https://www.careerpilot.co/privacy" target="_BLANK">Privacy Policy</b-link>
              </b-form-checkbox>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col sm="12">
              <b-form-group>
                <b-button 
                  variant="primary" 
                  size="lg" 
                  type="submit"
                  :disabled="!isCompanyValid || !compAgreed || errors.length > 0"
                >Register</b-button>
              </b-form-group>
            </b-col>
          </b-form-row>
        </form>

        <!-- Remind Passowrd -->
        <div id="formFooter">
          <b-link
            class="underlineHover"
            :to="{name: 'login', params:{companyLogin: true}}"
          >Already have an account? Login!</b-link>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "../styles/views/_register.scss";
</style>
<script>
import Auth from "@/fstore/auth";
import Company from "@/fstore/collections/Company";
import User from "@/fstore/collections/User";
var validator = require("email-validator");
export default {
  data() {
    return {
      agreed: false,
      compAgreed: false,
      view: false,
      viewConfirm: false,
      email: "",
      password: "",
      confirmPassword: "",
      errors: [],
      plans: [
        {
          value: "starter",
          text: "Starter - $0"
        },
        {
          value: "Basic",
          text: "Basic - $99"
        }
      ],
      company: {
        name: "",
        plan: { name: "Starter", price: 0 }
      }
    }; //end return
  }, //end data
  computed: {
    isValid: function() {
      return validator.validate(this.email) && this.password !== "";
    },
    isCompanyValid () {
      return validator.validate(this.email) && this.password !== "" && this.company.name !== "";
    }
  },
  methods: {
    toggleView() {
      this.view = !this.view;
    }, //end toggleView
    toggleConfirmView() {
      this.viewConfirm = !this.viewConfirm
    },
    confirmPasswordsMatch() {
      this.errors = []

      if (this.password != this.confirmPassword){
        this.errors.push("Password and Confirm password do not match.")
      }
    },
    async registerCompany() {
      // keep a reference for the component
      if (Auth.isLoggedIn()) {
        this.$store.dispatch("app/setAlert", {
            type: "danger",
            message: "You cannot create an account because you're currently logged. Please log out before creating a new account."
          });
        return;
      }
      this.$store.dispatch("app/setOverlay", true);
      try {
        const createdUser = await User.create({
          email: this.email,
          password: this.password,
          role: "company-owner"
        });
        // assign the user reference to the company
        this.company.user = createdUser.doc.uid;
        const result = await Company.create(this.company);

        this.$store.dispatch("app/setOverlay", false);
        if (!result.errors.length) {
          const verify = await this.$bvModal.msgBoxConfirm(
            "Please check your email to verify your account and get started.",
            {
              title: "Company Registration Complete"
            }
          );

          if (verify) {
            this.$router.push("/login");
          }
        } else {
          this.$store.dispatch("app/setAlert", {
            type: "danger",
            message: result.errors.join(", ")
          });
        }
      } catch (error) {
        console.error(error);
        let message = "";
        if (error.message) {
          message = error.message;
        } else if (error.errors) {
          error.errors;
          message = error.errors.join(", ");
        } else {
          message = "Something went wrong. Our developers are looking into it.";
        }
        this.$store.dispatch("app/setOverlay", false);
        this.$store.dispatch("app/setAlert", { type: "danger", message });
      }
    },
    async register() {
      if (Auth.isLoggedIn()) {
        this.$store.dispatch("app/setAlert", {
            type: "danger",
            message: "You cannot create an account because you're currently logged. Please log out before creating a new account."
          });
        return;
      }

      try {
        //check the email and password
        //activate the overlay
        this.$store.dispatch("app/setOverlay", true);

        // add the account
        let user = await User.create({
          email: this.email,
          password: this.password,
          role: "candidate"
        });

        if((user.errors && user.errors.length) || user.message){
          const message = user.errors? user.errors.join("\n") : user.message
          this.$store.dispatch("app/setOverlay", false);
          this.$store.dispatch("app/setAlert", {
            type: "danger",
            message: message
          }); //end dispatch alert
          return;
        }

        this.email = "";
        this.password = "";

        this.$store.dispatch("app/setOverlay", false);

        const confirm = await this.$bvModal.msgBoxConfirm(
          "Please check your email to verify your account and get started.",
          {
            title: "Registration Complete"
          }
        );

        if (confirm) {
          this.$router.push("/login");
        }
      } catch (error) {
        this.$store.dispatch("app/setOverlay", false);
        this.$store.dispatch("app/setAlert", {
          type: "danger",
          message: error.message
        }); //end dispatch alert
      }
    } //end register
  } //end methods
}; //end export
</script>
